<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                 <BreadCrumbs :crumbsParams="breadCrumbsDetails" />
              </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div  class="card-body">
  
                    <form @submit.prevent="submit" enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-12 col-sm-12">
                                <div class="form-group">
                                    <div class="controls">
                                        <!-- {{ track }} -->
                                        <label>Title(60 Characters max.)</label>
                                        <input type="text" v-model="track[0].title" class="form-control"
                                               placeholder="Title"
                                               required>
                                        <!-- <div v-if="track.errors.title" class="text-danger text-small">
                                            {{ track.errors.title }}
                                        </div> -->
                                    </div>
                                </div>
                                
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <input type="text" v-model="track[0].description" class="form-control"
                                               placeholder="Description"
                                               required>
                                        <!-- <div v-if="track.errors.description" class="text-danger text-small">
                                            {{ track.errors.description }}
                                        </div> -->
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="col-12 col-sm-12">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Upload Artwork</label>
                                        <file-pond
                                        v-if="true"
                                        name="test"
                                        ref="artworkImage"
                                        label-idle="Drag & drop artwork image"
                                        accepted-file-types="image/jpeg, image/png, image/gif"
                                        data-allow-reorder="true"
                                        data-max-file-size="2MB"
                                        :files="artworkImage"
                                        v-bind:allow-multiple="true"

                                    />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>File Url</label>
                                        <input type="text" class="form-control" 
                                               placeholder="File url"
                                               >
                                    </div>
                                </div>
                            </div>

                             <div class="col-12 col-sm-12">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Upload MP3 file only </label>
                                                <file-pond
                                                v-if="true"
                                                name="test"
                                                ref="mp3Image"
                                                label-idle="Drag & drop mp3 file"
                                                accepted-file-types="image/jpeg, image/png, image/gif"
                                                data-allow-reorder="true"
                                                data-max-file-size="2MB"
                                                :files="artworkImage"
                                                v-bind:allow-multiple="true"
                                                />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Upload track( Zip File)</label>
                                                <file-pond
                                                v-if="true"
                                                name="test"
                                                ref="trackImage"
                                                label-idle="Drag & drop track zip file"
                                                accepted-file-types="image/jpeg, image/png, image/gif"
                                                data-allow-reorder="true"
                                                data-max-file-size="2MB"
                                                :files="artworkImage"
                                                v-bind:allow-multiple="true"

                                                />
                                    </div>
                                </div>
                            </div> -->

                            <div class="col-12 col-sm-12">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Price</label>
                                        <input type="number" v-model="track[0].price" class="form-control"
                                               placeholder="Price"
                                               required>
                                        <!-- <div v-if="track.errors.price" class="text-danger text-small">
                                            {{ track.errors.price }}
                                        </div> -->
                                    </div>
                                </div>
                                <!-- <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Creator</label>
                                        <select v-model="track.creator" id="" class="form-control" required>
                                            <option value="" selected>Select a creator</option>
                                            <option v-for="creator in track_params.creators" :key="creator.id" :value="creator.name">
                                                {{ creator.name }}
                                            </option>
                                        </select>
                                       
                                    </div>
                                </div> -->
                            </div>

                            <div class="col-md-12 col-sm-12">
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1">Update</button>
                            </div>
                        </div>
                    </form> 
                </div>
            </section>
        </div>
    </div>
</template>

<script>

import Layout from '@/Shared/Layout';
import ValidationErrors from "../../Shared/ValidationErrors";
import BreadCrumbs from '@/Shared/BreadCrumbs';
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import {VueEditor} from "vue2-editor";
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { Link } from '@inertiajs/inertia-vue';


const FilePond = vueFilePond(
    FilePondPluginFileValidateType, 
    FilePondPluginImagePreview,
    FilePondPluginFilePoster
    );



export default {
    metaInfo: {title: 'Edit track'},
    name: 'trackEdit',
    layout: Layout,
    props: ['track'],
    components: {
        BreadCrumbs,
        ValidationErrors,
        FilePond,
        Link,
    },
    data() {
        return {
            breadCrumbsDetails: {
                link: "admin.tracks.index",
                linkPage: "All Tracks",
                currentPage: "Edit track",
            },
            artworkImage: [],
            mp3Image: [],
            trackImage: [],
            // myFiles: []

        }
    },
    methods: {
        submit(){
            // console.log(this.track[0].id); 
            this.$inertia.put(route('admin.tracks.update',this.track[0].id),this.track);
        },
        // submit(){
        //         const formData = new FormData();
        //         const artworkUploaded = this.$refs.artworkImage.getFiles();
        //         const mp3Uploaded = this.$refs.mp3Image.getFiles();
        //         const trackUploaded = this.$refs.trackImage.getFiles();

        //         // formData.append('artworkfile',artworkUploaded);
        //         // formData.append('mp3file',mp3Uploaded);
        //         // formData.append('trackfile',trackUploaded);
                
        //         // if (artworkUploaded.length > 0) {
        //         //     artworkUploaded.forEach(function(file) {
        //         //             // console.log(file.file);
        //         //             this.track.artworkfile.append(file.file);
        //         //     }) 
        //         //     formData.append('artworkfile', this.track.artworkfile);

                    
        //         // }

                
        //         if (artworkUploaded.length > 0) {
        //             artworkUploaded.forEach(file => formData.append('artworkfile', file.file));
        //             // console.log(file.file);
        //         }

        //         if (mp3Uploaded.length > 0) {
        //             mp3Uploaded.forEach(file => formData.append('mp3file', file.file));
        //             // console.log(file.file);
        //         }
        //         if (trackUploaded.length > 0) {
        //             trackUploaded.forEach(file => formData.append('trackfile', file.file));
        //             // console.log(file.file);
        //         }
        //         // console.log(uploadedFiles[0].file);
                
        //         // add post key value pair
        //         // Object.keys(this.album).forEach(album => formData.append(album, this.album[album]));

        //         this.$inertia.post(route('Tracks.store',this.track), formData);

        // },
        handleFilePondInit(){
                // if(this.form.image)
                // {
                //     this.myFiles = [{
                //         source: '/' + this.form.image,
                //         options: {
                //             type: 'local',
                //             metadata: {
                //                 poster: '/' + this.form.image
                //             }
                //         }
                //     }];
                // }else{
                //     this.myFiles = [];
                // }
            },
        handleFilePondLoad(response)
            {
                // this.form.myFiles = response;
            },
        

    }

 }

</script>
